import { useEffect, useRef } from 'react';
export var useEffectWithoutInitCall = function useEffectWithoutInitCall(effect, deps) {
  var isMountedRef = useRef(false);
  useEffect(function () {
    if (isMountedRef.current) {
      effect();
    }
  }, deps);
  useEffect(function () {
    isMountedRef.current = true;
    return function () {
      isMountedRef.current = false;
    };
  }, []);
};